import { cornerDetectionUrl } from '../constants/constants';

/**
 * get the closest dot to the clicked or touched point
 * @param {number} X of the clicked or touched area
 * @param {number} Y of the clicked or touched area
 * @param {array}  array of dots in the form of object with x and y
 */
export function getClosestPoint(X, Y, dots) {
    let closestDot;
    let currentIndex = 0;
    dots.forEach((dot, index) => {
        const xDist = Math.pow(Math.abs(dot.x - X), 2);
        const yDist = Math.pow(Math.abs(dot.y - Y), 2);
        const distance = xDist + yDist;
        console.log("xDist", xDist, "yDist", yDist, currentIndex);
        if (!closestDot || distance < closestDot) {
            closestDot = distance;
            currentIndex = index;
        }
    });
    return {
        closestDot: closestDot,
        closestIndex: currentIndex
    };
}

/**
 * Get the corner points of an image for cropping from the server
 * the result contains an image response from the server and four
 * points which are the corners of the image to be cropped.
 * @param {string} url of the api
 * @param {formData} the file attached to a formData to be sent
 */
export function cornerPointsRequest(url, formData) {
    return new Promise((resolve, reject) => {
        fetch(`${url}`, {
            method: "POST",
            mode: "cors",
            credentials: "same-origin",
            body: formData
        })
            .then(response => response.json())
            .then(result => {
                const points = JSON.parse(result.points);
                resolve({ points: points, image: result.image });
            });
    });
}

/**
 * Recieve image data and return a new canvas with the image data.
 * @param {imageData} part of image to be saved from a canvas
 * @param {integer} Canvas width is set to this
 * @param {integer} Canvas height is set to this
 */

export function createSelectedImageCanvas(imageData, canvasW, canvasH) {
    const tmpCanvas = document.createElement("canvas");
    tmpCanvas.width = canvasW;
    tmpCanvas.height = canvasH;
    const ctx1 = tmpCanvas.getContext("2d");
    ctx1.rect(0, 0, tmpCanvas.width, tmpCanvas.height);
    ctx1.fillStyle = "white";
    ctx1.fill();
    ctx1.putImageData(imageData, 0, 0);
    return tmpCanvas;
}

/**
 * Recieve base64 and convert it to a file wich can be attached to a form.
 * @param {string} base64 image data
 * @param {string} filename
 */
export function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}



/**
 * recieve a canvas and draw line on the canvas from dot1 to dot2
 * @param dot1={x:Num,y:Num} an object with x and y coordinates
 * @param dot2={x:Num,y:Num} an object with x and y coordinates
 * @param canvas the canvas document element to be drawn on
 * @param color of the drawn line
 */
export function drawLine(dot1, dot2, canvas, color) {
    const ctx = canvas.getContext("2d");
    ctx.beginPath();
    ctx.lineWidth = 2;
    ctx.moveTo(dot1.x, dot1.y);
    ctx.lineTo(dot2.x, dot2.y);
    ctx.strokeStyle = color;
    ctx.stroke();
    ctx.lineWidth = 1;
}

/**
 * recieve a canvas and draw dot1 
 * @param dot1={x:Num,y:Num} an object with x and y coordinates
 * @param canvas the canvas document element to be drawn on
 * @param color of the drawn line
 */
export function drawDot(dot, canvas, color) {
    const ctx = canvas.getContext("2d");
    ctx.beginPath();
    ctx.fillStyle = color;
    ctx.fillRect(dot.x - 4, dot.y - 4, 8, 8);
}
/**
 * asyncrous function with a promise
 * simple draw image on canvas
 * @param {image} image 
 * @param {canvas} canvas 
 */
export function drawImage(image, canvas) {
    return new Promise((resolve, reject) => {

        let img = new Image();
        img.addEventListener('load', () => {
            const ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0, img.width, img.height);
            return resolve(true);
        });
        img.src = image;
    });
}
/**
 * asyncrous function with a promise 
 * draws an image with scaling 
 * returns an object with ratio of the original and the with ration
 * @param {image} image 
 * @param {canvas} canvas 
 */
export function drawImageScaled(image, canvas) {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.addEventListener('load', () => {
            const ctx = canvas.getContext("2d");
            const hRatio = canvas.width / img.width;
            const vRatio = canvas.height / img.height;
            const ratio = Math.min(hRatio, vRatio);
            const centerShiftX = (canvas.width - img.width * ratio) / 2;
            const centerShiftY = (canvas.height - img.height * ratio) / 2;
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            console.log("centerShiftX", centerShiftX, "CenterShiftY", centerShiftY);
            ctx.drawImage(img, 0, 0, img.width, img.height, centerShiftX, centerShiftY, img.width * ratio, img.height * ratio);

            return resolve({ ratio, img, centerShift: { centerShiftX, centerShiftY } });
        });

        img.src = image;
    });
    // if (!this.imagePosition) {
    //     this.imagePosition = {
    //         x0: centerShiftX,
    //         y0: centerShiftY,
    //         x1: centerShiftX + image.width * ratio,
    //         y1: centerShiftY + image.height * ratio
    //     }
    //     initial emit
    //     this.emitImagePosition()
    //     this.$emit('ratio', ratio)
    // }

}

function drawImageOriginal(image, originalCanvas) {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.addEventListener('load', () => {
            const originalImageCtx = originalCanvas.getContext("2d");
            // draw origin image
            const originalImageCanvas = originalImageCtx.canvas;
            const ohRatio = originalImageCanvas.width / image.width;
            const ovRatio = originalImageCanvas.height / image.height;
            const ratio = Math.min(ohRatio, ovRatio);
            const ocenterShiftX = (originalImageCanvas.width - image.width * ratio) / 2;
            const ocenterShiftY = (originalImageCanvas.height - image.height * ratio) / 2;

            originalImageCtx.clearRect(0, 0, originalImageCanvas.width, originalImageCanvas.height);
            console.log(originalImageCtx);
            originalImageCtx.drawImage(img, 0, 0, img.width, img.height, ocenterShiftX, ocenterShiftY, img.width * ratio, img.height * ratio);

            return resolve({ ratio, img });
        });

        img.src = image;
    });

    // this.drawImageShadow()


}
/**
 * find closest dot to a given point in an array of dots
 * @param array an array of dots
 * @param mouseX -> any point 
 * @param mouseY ->
 */
export function closestDot(dots, mouseX, mouseY) {
    let dist;
    let index, pt;
    console.log(dots)
    dots.forEach((dot, i) => {
        const dx = Math.abs(dot.x - mouseX);
        const dy = Math.abs(dot.y - mouseY);
        const thisDist = Math.pow(dx, 2) + Math.pow(dy, 2);
        console.log("closest", dot.x, dot.y, dx, dy, 'mouse', mouseX, mouseY, thisDist);

        if (!dist || thisDist < dist) {
            dist = thisDist;
            pt = { x: dot.x, y: dot.y };
            index = i;
        }
    });

    const closest = dots[index];
    return { pt, closest, closestIndex: index, };
}

export function onFileChanged(file, canvas) {
    //check file existence
    if (!file) return { status: false, code: 'NO_FILE' };

    //check file type
    if (
        file.type !== 'image/jpeg' &&
        file.type !== 'image/jpg' &&
        file.type !== 'image/png' &&
        file.type !== 'application/tif' &&
        file.type !== 'image/tiff' &&
        file.type !== 'application/pdf'
    ) {
        return { status: false, code: 'WRONG_EXTENSION' };
    }

    //check file size
    if (file.size > 1024 * 1024 * 16) {
        return { status: false, code: 'FILE_TOO_BIG' };
    }



}

/** 
 * draw the corners of the processed image on canvas
 * the dots are received from the server response
 */
export function drawImageBoundary(dots, canvas, ratio, img) {
    const color = '#80D';
    const ctx = canvas.getContext("2d");
    // ctx.clearRect(0, 0, canvas.width, canvas.height);

    // // draw black

    // const points = [];
    // for (let i = 0; i < this.dots.length; i++) {
    //     points.push({ x: this.dots[i].x, y: this.dots[i].y });
    // }
    // points.push({ x: this.dots[0].x, y: this.dots[0].y });

    // points.push({ x: this.imagePosition.x0, y: this.imagePosition.y0 });
    // points.push({ x: this.imagePosition.x0, y: this.imagePosition.y1 });
    // points.push({ x: this.imagePosition.x1, y: this.imagePosition.y1 });
    // points.push({ x: this.imagePosition.x1, y: this.imagePosition.y0 });
    // points.push({ x: this.imagePosition.x0, y: this.imagePosition.y0 });
    console.log("canvasW", canvas.width, "img width", img.width, "ratio", ratio)
    // const centerShiftX = (canvas.width - img.width * ratio) / 2;
    // const centerShiftY = (canvas.height - img.height * ratio) / 2;
    ctx.beginPath();
    // ctx.moveTo(this.imagePosition.x0, this.imagePosition.y0);

    // for (let i = 0; i < points.length; i++) {
    //     ctx.lineTo(points[i].x, points[i].y);
    // }

    // ctx.fillStyle = this.background;
    // ctx.fill();
    const scaledDots = dots.map(d => ({ x: (d.x), y: (d.y) }));
    console.log("scaled", scaledDots)
    // console.log(dots)
    for (let i = 0; i < scaledDots.length; i++) {
        drawDot(scaledDots[i], canvas, color);
        drawLine(
            scaledDots[i],
            scaledDots[i + 1] || scaledDots[0], canvas,
            color
        );
    }

}
export function drawImageBoundaryScaled(dots, canvas, ratio, img) {
    console.log("dots", dots)
    const color = '#007bff';
    const ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // // draw black

    // const points = [];
    // for (let i = 0; i < this.dots.length; i++) {
    //     points.push({ x: this.dots[i].x, y: this.dots[i].y });
    // }
    // points.push({ x: this.dots[0].x, y: this.dots[0].y });

    // points.push({ x: this.imagePosition.x0, y: this.imagePosition.y0 });
    // points.push({ x: this.imagePosition.x0, y: this.imagePosition.y1 });
    // points.push({ x: this.imagePosition.x1, y: this.imagePosition.y1 });
    // points.push({ x: this.imagePosition.x1, y: this.imagePosition.y0 });
    // points.push({ x: this.imagePosition.x0, y: this.imagePosition.y0 });

    const centerShiftX = (canvas.width - img.width * ratio) / 2;
    const centerShiftY = (canvas.height - img.height * ratio) / 2;
    ctx.beginPath();
    // ctx.moveTo(this.imagePosition.x0, this.imagePosition.y0);

    // for (let i = 0; i < points.length; i++) {
    //     ctx.lineTo(points[i].x, points[i].y);
    // }

    // ctx.fillStyle = this.background;
    // ctx.fill();
    const scaledDots = dots.map(d => ({ x: (d.x * ratio) + centerShiftX, y: (d.y * ratio) + centerShiftY }));
    console.log("scaled", scaledDots)
    // console.log(dots)
    for (let i = 0; i < scaledDots.length; i++) {
        drawDot(scaledDots[i], canvas, color);
        drawLine(
            scaledDots[i],
            scaledDots[i + 1] || scaledDots[0], canvas,
            color
        );
    }

    //dark surrounding shadow
    ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
    ctx.beginPath();
    ctx.lineTo(scaledDots[0].x, scaledDots[0].y);
    ctx.lineTo(scaledDots[1].x, scaledDots[1].y);
    ctx.lineTo(scaledDots[2].x, scaledDots[2].y);
    ctx.lineTo(scaledDots[3].x, scaledDots[3].y);
    ctx.rect(canvas.width, 0, -canvas.width, canvas.height);
    ctx.fill();
    // ctx.beginPath();
    /* ctx.moveTo(10, 10); */
    // ctx.lineTo(50, 50);
    // ctx.lineTo(100, 100);
    // ctx.lineTo(200, 150);
    // ctx.lineTo(10, 150);
    // ctx.rect(200, 0, -200, 200);
    // ctx.fill();

}

/**
 * 
 * @param {array} selection of points as an array [{x:point,y:point}]
 * @param {canvas}  Imagedrawer canvas
 * @param {canvas} originalCanvas 
 * @param {canvas} resultCanvas 
 */

export function getImageFromSelectedArea(selection, canvas, originalCanvas, resultCanvas, ratio, scale) {
    console.log(selection, scale)
    ratio = 1;
    const originalCtx = originalCanvas.getContext("2d");
    const resultCtx = resultCanvas.getContext("2d");
    const ratioX = originalCanvas.width / canvas.width;
    const ratioY = originalCanvas.height / canvas.height;

    const scaledDots = selection.map(d => ({ x: (d.x * ratio), y: (d.y * ratio) }));

    //extract X and Y of the selected area
    const arrayOfX = scaledDots.map(d => d.x);
    const arrayOfY = scaledDots.map(d => d.y);

    // get coordinates in preview canvas
    let maxX = Math.max(...arrayOfX);
    let maxY = Math.max(...arrayOfY);
    let minX = Math.min(...arrayOfX);
    let minY = Math.min(...arrayOfY);

    // update preview coordinates to fit original size image
    // maxX = maxX * ratioY;
    // maxY = maxY * ratioY;
    // minX = minX * ratioY;
    // minY = minY * ratioY;

    const imageWidth = maxX - minX;
    const imageHeight = maxY - minY;

    resultCtx.clearRect(0, 0, resultCanvas.width, resultCanvas.height);

    resultCanvas.width = imageWidth;
    resultCanvas.height = imageHeight;

    let imageData = originalCtx.getImageData(
        minX,
        minY,
        imageWidth,
        imageHeight
    );

    const selectedImageCanvas = createSelectedImageCanvas(
        imageData,
        imageWidth,
        imageHeight
    );
    document.body.appendChild(selectedImageCanvas);
    // resultCtx.drawImage(
    //     originalCanvas,
    //     minX,
    //     minY,
    //     imageWidth,
    //     imageHeight,
    //     0,
    //     0,
    //     imageWidth,
    //     imageHeight
    // );

    return resultCtx;
}

/**
 * redraw the canvas after zoom
 * @param {canvas} canvas 
 * @param {canvas} originalCanvas 
 */
export function redraw(canvas, originalCanvas) {
    const ctx = canvas.getContext("2d");
    const originalImageCtx = originalCanvas.getContext("2d");
    trackTransforms(ctx);
    trackTransforms(originalImageCtx);

    // Clear the entire canvas

    // const p1 = ctx.transformedPoint(0, 0);
    // const p2 = ctx.transformedPoint(canvas.width, canvas.height);
    // ctx.clearRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);

    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    // ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();

    // apply to original image canvas

    // const op1 = originalImageCtx.transformedPoint(0, 0);
    // const op2 = originalImageCtx.transformedPoint(originalImageCtx.canvas.width, originalImageCtx.canvas.height);
    // originalImageCtx.clearRect(op1.x, op1.y, op2.x - op1.x, op2.y - op1.y);

    originalImageCtx.save();
    originalImageCtx.setTransform(1, 0, 0, 1, 0, 0);
    // originalImageCtx.clearRect(0, 0, originalImageCtx.canvas.width, originalImageCtx.canvas.height);
    originalImageCtx.restore();
    drawImageScaled(originalCanvas.toDataURL(), canvas);
    drawImageScaled(originalCanvas.toDataURL(), originalCanvas);
}

/**
 * zoom with scale and redraw the canvases with new scaling
 * @param {Number} newScale 
 * @param {Number} currentScale
 * @param {canvas} canvas 
 * @param {canvas} originalCanvas 
 */
export function scale(newScale, currentScale, canvas, originalCanvas) {
    console.log('newScale', newScale, 'currentScale', currentScale)

    let factor = +(newScale - currentScale).toFixed(2);
    if (factor < 0) {
        factor = -1 / factor;
    }
    const ctx = canvas.getContext("2d");
    ctx.scale(factor, factor);
    // apply to original image canvas

    const originalImageCtx = originalCanvas.getContext("2d");
    originalImageCtx.scale(factor, factor);


    redraw(canvas, originalCanvas);


    // scale coordination
    // this.imagePosition = {
    //     x0: +(this.imagePosition.x0 * factor).toFixed(5),
    //     y0: +(this.imagePosition.y0 * factor).toFixed(5),
    //     x1: +(this.imagePosition.x1 * factor).toFixed(5),
    //     y1: +(this.imagePosition.y1 * factor).toFixed(5)
    // }

}
/**
 * additional internal functions for canvas zoom and move
 * @param {canvas ctx} ctx 
 */
function trackTransforms(ctx) {
    /**
     * explanation: https://gist.github.com/dzhang123/2a3a611b3d75a45a3f41
     */
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    let xform = svg.createSVGMatrix();
    ctx.getTransform = function () { return xform; };

    const savedTransforms = [];
    const save = ctx.save;
    ctx.save = function () {
        savedTransforms.push(xform.translate(0, 0));
        return save.call(ctx);
    };

    const restore = ctx.restore;
    ctx.restore = function () {
        xform = savedTransforms.pop();
        return restore.call(ctx);
    };

    const scale = ctx.scale;
    ctx.scale = function (sx, sy) {
        xform = xform.scaleNonUniform(sx, sy);
        return scale.call(ctx, sx, sy);
    };

    const rotate = ctx.rotate;
    ctx.rotate = function (radians) {
        xform = xform.rotate(radians * 180 / Math.PI);
        return rotate.call(ctx, radians);
    };

    const translate = ctx.translate;
    ctx.translate = function (dx, dy) {
        xform = xform.translate(dx, dy);
        return translate.call(ctx, dx, dy);
    };

    const transform = ctx.transform;
    ctx.transform = function (a, b, c, d, e, f) {
        const m2 = svg.createSVGMatrix();
        m2.a = a; m2.b = b; m2.c = c; m2.d = d; m2.e = e; m2.f = f;
        xform = xform.multiply(m2);
        return transform.call(ctx, a, b, c, d, e, f);
    };

    const setTransform = ctx.setTransform;
    ctx.setTransform = function (a, b, c, d, e, f) {
        xform.a = a;
        xform.b = b;
        xform.c = c;
        xform.d = d;
        xform.e = e;
        xform.f = f;
        return setTransform.call(ctx, a, b, c, d, e, f);
    };

    const pt = svg.createSVGPoint();
    ctx.transformedPoint = function (x, y) {
        pt.x = x; pt.y = y;
        return pt.matrixTransform(xform.inverse());
    };
}

export function selectTool(selected){
    const buttons = document.querySelectorAll('.control-btn');
    console.log(buttons);
    buttons.forEach(button=>{
        button.classList.remove('active-tool');
        if (button.classList.contains(selected)){
            button.classList.add('active-tool');
        }
        
    });
    
}
